import { useApplicationContext } from '~/shared/context/use-application-context';

import type { CommentAuthor } from './types';

const FALLBACK_AUTHOR_ID = 'local-user';

export const useCurrentCommentAuthor = (): CommentAuthor => {
    const { applicationState } = useApplicationContext();
    const profile = applicationState.myUserProfile;
    const id = profile.get('id').unwrapOr(FALLBACK_AUTHOR_ID);
    const firstName = profile.get('firstName').unwrapOr('');
    const lastName = profile.get('lastName').unwrapOr('');
    return { id, firstName, lastName };
};
